import React, { useCallback, useEffect, useState } from 'react';
import { selectedServices } from '../../../mockdata/common';
import Collapse from './Collapse';
import EstimatedCost from './EstimatedCost';
import PaymentModal from './PaymentModal';
import AgreementModal from './AgreementModal';
import ServicesEstimate from './ServicesEstimate';
import Button from '../../../components/Button';
import ProcessOrderModal from './ProcessOrderModal';

export default function OrderSummary({ setstep }) {
  const tenantName = import.meta.env.VITE_TENANT_NAME;
  const [services, setServices] = useState(selectedServices);
  const [orderProcessModal, setOrderProcessModal] = useState(false);
  return (
    <div>
      <div className='max-w-9xl mx-auto w-full'>
        <div className='grid grid-cols-12 gap-4 sm:gap-6'>
          <Collapse services={services} />
          <div className='col-span-full flex flex-col sm:col-span-5'>
            <ServicesEstimate lastRender={true} />
            <div className='mt-8 flex flex-row items-center justify-center'>
              <p className='mb-2 text-sm font-semibold text-gray-700'>
                Confirmation is agreement to our{' '}
                <a
                  href={
                    tenantName === 'laundrycare'
                      ? 'https://www.laundrycare.biz/tos/'
                      : 'https://www.pushlaundry.com/tos/'
                  }
                  className='text-sm text-blue-500 underline'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Terms of Service
                </a>
              </p>
            </div>
            <Button
              variant='primary-dark'
              text='Confirm'
              classes='w-full'
              onClick={(e) => setOrderProcessModal(true)}
            />
          </div>
        </div>
      </div>
      <ProcessOrderModal
        orderProcessModal={orderProcessModal}
        setOrderProcessModal={() => setOrderProcessModal}
        setstep={setstep}
      />
    </div>
  );
}
